import { Component, HostListener, OnInit } from "@angular/core";
import { AppService } from "../services/app.service";
import { HttpService } from "../services/http.service";
import { AmplifyService } from "../services/amplify.service";
import { AlertController } from "@ionic/angular";
import { ActivatedRoute, Router } from "@angular/router";
import { Title } from "@angular/platform-browser";

declare var mapsAutocomplete;
declare var mapsLocationDetails;

@Component({
  selector: "app-admin",
  templateUrl: "./admin.page.html",
  styleUrls: ["./admin.page.scss"],
})
export class AdminPage implements OnInit {
  flags: any;
  public isColumnVisible = true;

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.checkScreenSize();
  }

  constructor(
    private app: AppService,
    private http: HttpService,
    public amplify: AmplifyService,
    public alertController: AlertController,
    private router: Router,
    public title: Title
  ) {
    this.checkScreenSize();
    this.flags = {
      userData: { email: null, password: null, error: null },
      stepData: {
        email: null,
        password1: null,
        password2: null,
        confirmation: false,
        verificationcode: null,
        error: null,
      },
      step: 1,

      copyTo: null,
      transferList: [],

      mode: "1",
      companyList: [],
      usersList: [],
      usersResult: [],
      groupsList: [],
      groupsResult: [],
      locationsList: [],
      searchFocus: 0,
      modalMode: null,
      modalItem: null,
      modalStep: 1,
      usersSearch: null,
      groupsSearch: null,
      currentUser: null,
      usersFlag: "0",

      editCompany: null,
      editUser: null,
      editAccess: null,

      editGroupIndex: null,
      editGroup: null,
      checkbox: false,

      defaultCompany: {
        name: null,
        token: null,
        permission: "default",
        status: "active",
        industry: null,
        user_licenses: null,
      },

      defaultUser: {
        cid: null,
        company_id: this.app.sysData.company_id,
        epoch: null,
        practitioner_id: null,
        first_name: null,
        last_name: null,
        suite: null,
        address: null,
        city: null,
        state: null,
        country: null,
        zip: null,
        lat: null,
        lng: null,
        email: null,
        phone: null,
        status: null,
        meta: null,
      },

      defaultAccess: {
        cid: null,
        company_id: this.app.sysData.company_id,
        location_id: null,
        group_id: null,
        epoch: null,
        permissions: null,
        token: null,
      },

      userAccess: [],

      addressSearch: null,
      matches: { address: [], googleResult: [], patientsGroup: [] },
    };
  }

  getData() {
    this.getUsers();
    this.getCompanies();
    //this.getLocations();
    //this.reset();
  }
  ionViewDidEnter() {
    if (this.app.sysData.company_id == 1) {
      this.getData();
    } else {
      this.viewPage("home");
    }
  }

  viewPage(m) {
    this.router.navigateByUrl("/" + m);
  }

  checkScreenSize() {
    // This ensures that on larger screens, the visibility is handled automatically,
    // but on smaller screens, the column remains visible unless toggled.
    if (window.innerWidth >= 768) {
      this.isColumnVisible = true; // Always visible on larger screens
    } else {
      // Do not automatically hide on mobile; respect the current toggle state
      // Remove or comment out this line if you want it always visible when reloading the page on mobile:
      // this.isColumnVisible = false;
    }
  }

  toggleColumn() {
    if (window.innerWidth < 768) {
      // Change 768 to your desired breakpoint for smaller screens
      this.isColumnVisible = !this.isColumnVisible;
    }
  }

  getCompanies() {
    this.http.apiGet("company?orderby=name", {}).then((data) => {
      console.log("company list", data);
      this.flags.companyList = data.data;
      this.flags.transferList = data.data;
    });
  }

  getUsers() {
    //this.http.apiGet('user_accounts/?join=user_access,cid,cid,id:company_id', {}).then(data => {

    this.http.apiGet("user_accounts/pin/0000?joinarray=user_access,cid,cid&orderby=first_name", {}).then((data) => {
      console.log("user list", data);
      this.flags.usersList = data.data;
      this.flags.usersResult = data.data;
    });
  }

  getLocations() {
    this.http.apiGet("company_sites/company_id/" + this.app.sysData.company_id, {}).then((data) => {
      console.log("location list", data.data);
      this.flags.locationsList = data.data;
    });
  }

  openModal(m, params) {
    this.flags.modalMode = m;
    if (m == 1) {
      //new company
      this.flags.modalData = JSON.parse(JSON.stringify(params));
    }

    if (m == 2) {
      //new user
      this.flags.modalData = JSON.parse(JSON.stringify(this.flags.defaultUser));
      this.flags.step = 2;
    }
    if (m == 2.1) {
      //edit user
      this.flags.modalData = JSON.parse(JSON.stringify(params));
    }

    if (m == 3) {
      //new access
      var obj = JSON.parse(JSON.stringify(this.flags.defaultAccess));
      obj.epoch = Date.now();
      obj.cid = this.flags.editUser.cid;
      this.flags.editAccess = obj;
    }

    if (m == 4) {
      //copy experience
      this.flags.copyTo = null;
      this.flags.matches.googleResult = [];
      this.flags.modalData = JSON.parse(JSON.stringify(params));
      this.flags.transferList = JSON.parse(JSON.stringify(this.flags.companyList));
      this.getCategories();
    }
  }

  closeModal() {
    this.flags.modalMode = null;
  }

  getCategories() {
    this.http
      .apiGet("repo_categories/site_id/" + this.flags.modalData.id + "?&orderby=type+asc:priority:name", null)
      .then((data) => {
        var obj = data.data;

        obj.forEach((el) => {
          el.copyTo = true;
          el.entries = JSON.parse(el.entries);
        });

        this.flags.categoryList = obj;
        console.log("CATEGORY List", data.data);
      });
  }

  //END LOGIN FUNCTIONS

  processTransfer() {
    this.app.load("Processing...", 10000);
    console.log("this.flags.transferList", this.flags.transferList);
    //this.app.alert(this.flags.transferList);

    var arr = [];
    this.flags.transferList.forEach((el) => {
      if (el.copyTo) {
        arr.push(el);
      }
    });

    console.log("transfer to arr", arr);
    for (var i = 0; i < arr.length; i++) {
      var obj = JSON.parse(JSON.stringify(this.flags.modalData));
      obj.company_id = arr[i].id;
      obj.epoch = Date.now();
      obj.settings = JSON.stringify(obj.settings);
      delete obj.id;
      //obj.cid = this.app.sysData.company_id;
      //obj.user_id = this.app.sysData.user_id;
      //obj.status = 'active';

      this.http.apiPost("company_sites", { data: obj }, null).then((data) => {
        console.log("site added", data);
        this.processCategories(data["data"].insertId);
      });
    }
  }

  async processCategories(site_id) {
    this.flags.categoryList.forEach((el, index) => {
      if (el.copyTo) {
        var obj = JSON.parse(JSON.stringify(el));
        obj.site_id = site_id;
        obj.entries = JSON.stringify(obj.entries);
        delete obj.id;
        delete obj.copyTo;

        var push = this.pushCategory(obj);
        console.log("pushed catgory to " + site_id, push);
      }
      if (index === this.flags.categoryList.length - 1) {
        //using index here
        this.app.stopload();
        this.app.toast("Transfer Complete", "success");
        this.flags.editCompany = null;
        this.closeModal();
      }
    });
  }

  async pushCategory(obj) {
    console.log("ABOUT TO PUSH THIS DATA TO CATEGORY", obj);
    this.http.apiPost("repo_categories", { data: obj }, null).then((data) => {
      console.log("category added", data);
    });
  }

  //ADDRESS SEARCH
  async searchLocation() {
    if (this.flags.modalData.address) {
      mapsAutocomplete(this.flags.modalData.address).then((data) => {
        console.log("Google results", data);
        this.flags.matches.googleResult = JSON.parse(JSON.stringify(data));
      });
    }
  }

  selectLocation(i) {
    this.flags.modalData.address = this.flags.matches.googleResult[i].structured_formatting.main_text;
    this.flags.modalData.place_id = this.flags.matches.googleResult[i].place_id;

    mapsLocationDetails(this.flags.matches.googleResult[i].place_id).then((data) => {
      console.log("Selection results ", data);

      //this.app.alert(obj[i].short_name);
      this.flags.modalData.lat = data[0].geometry.location.lat;
      this.flags.modalData.lng = data[0].geometry.location.lng;

      var obj = data[0].address_components;
      for (var i = 0; i < obj.length; i++) {
        for (var j = 0; j < obj[i].types.length; j++) {
          //if (obj[i].types[j] == "route") { this.flags.editPost.address = obj[i].long_name}

          if (obj[i].types[j] == "locality") {
            this.flags.modalData.city = obj[i].long_name;
          }
          if (obj[i].types[j] == "administrative_area_level_1") {
            this.flags.modalData.state = obj[i].long_name;
          }
          if (obj[i].types[j] == "country") {
            this.flags.modalData.country = obj[i].long_name;
          }
          if (obj[i].types[j] == "postal_code") {
            this.flags.modalData.zip = obj[i].short_name;
          }
        }
      }

      this.flags.matches.googleResult = [];
      this.flags.addressSearch = null;
    });
  }
  //END GOOGLE ADDRESS SEARCH

  resetStep() {
    this.flags.stepData = {
      email: null,
      password1: null,
      password2: null,
      confirmation: false,
      verificationcode: null,
      error: null,
    };
    this.flags.step = 2;
    this.amplify.signOut();
  }

  step(m) {
    this.flags.stepData = {
      email: null,
      password1: null,
      password2: null,
      confirmation: false,
      verificationcode: null,
      error: null,
    };
    this.flags.step = m;
  }

  //PASSWORD FUNCTIONS
  register() {
    console.log("register run");
    this.flags.stepData.error = null;
    if (this.flags.stepData.password1 == this.flags.stepData.password2) {
      console.log("passwords match");
      this.amplify.registerUser(this.flags.stepData.email, this.flags.stepData.password1).then(
        (res) => {
          if (res["codeDeliveryDetails"]["Destination"]) {
            //this.app.alert(JSON.stringify(res));
            console.log(res);
            this.app.alert("Confirmation Email sent to: " + res["user"]["username"]);
            //this.promptVerificationCode();
            this.resetStep();
          }
        },
        (err) => {
          //this.app.toast('failed ' + JSON.stringify(err), 'danger');
          this.flags.stepData.error = err.message;
          console.log(err);
        }
      );
    } else {
      console.log("passwords do not match");
      this.flags.stepData.error = "Your passwords do not match";
    }
  }

  resendVerificationCode() {
    this.flags.stepData.error = null;
    this.amplify.resendConfirmationCode(this.flags.stepData.email).then(
      (res) => {
        this.app.alert("Confirmation resent");
      },
      (err) => {
        console.log(err);
        this.flags.stepData.error = err.message;
      }
    );
  }

  forgotPassword() {
    this.amplify.forgotPassword(this.flags.stepData.email).then(
      (res) => {
        console.log(res);
        //this.flags.stepData.message = 'Reset Code sent to ' + JSON.stringify(res['CodeDeliveryDetails']['Destination']);
        this.app.toast("Reset Code sent to " + JSON.stringify(res["CodeDeliveryDetails"]["Destination"]), "success");
        this.flags.step = 5.1;
        this.flags.stepData.error = null;
      },
      (err) => {
        console.log("failed", err);
        this.flags.stepData.error = err.message;
      }
    );
  }

  forgotPasswordConfirmation() {
    this.flags.stepData.error = null;
    if (this.flags.stepData.password1 == this.flags.stepData.password2) {
      this.amplify
        .resetPassword(this.flags.stepData.email, this.flags.stepData.verificationcode, this.flags.stepData.password1)
        .then(
          (res) => {
            console.log(res);
            this.app.alert("Password Reset Please Login");
            this.resetStep();
          },
          (err) => {
            console.log("failed", err);
            this.flags.stepData.error = err.message;
          }
        );
    } else {
      this.flags.stepData.error = "Your passwords do not match";
    }
  }

  promptVerificationCode() {
    this.flags.step = 3;
    this.flags.stepData.verificationcode = null;
  }
  //END PASSWORD FUNCTIONS

  addItem(m) {
    if (m == 1) {
      //new company
      var obj = JSON.parse(JSON.stringify(this.flags.defaultCompany));
      obj.token = Date.now();
      this.flags.editCompany = obj;
    }
  }

  modItem(m, item) {
    //this.flags.mode = m
    if (m == 1.1) {
      this.flags.editUser = JSON.parse(JSON.stringify(item));
    }

    if (m == 2.1) {
      this.flags.editCompany = JSON.parse(JSON.stringify(item));
      this.flags.sitesList = [];
      this.flags.sitesResults = [];
      this.getSites();
    }
  }

  getSites() {
    this.http.apiGet("company_sites/company_id/" + this.flags.editCompany.id, null).then((data) => {
      console.log("get sites", data.data);
      var temp = this.app.sysData.userAccess.find((el) => el.id === this.app.sysData.company_id); //find returns a single item with match
      this.flags.total_archive_licenses = temp.archive_licenses;

      var obj = data.data;
      this.flags.used_archive_licenses = obj.length; //current licenses being used

      for (var i = 0; i < obj.length; i++) {
        obj[i].settings = JSON.parse(obj[i].settings);
      }
      this.flags.sitesList = data.data;
      this.flags.sitesResults = data.data;
    });
  }

  //SAVE
  saveItem(m) {
    if (m == 1) {
      //SAVE NEW COMPANY
      var obj = JSON.parse(JSON.stringify(this.flags.editCompany));
      this.http.apiPost("company", { data: obj }, null).then((data) => {
        this.app.toast("Saved", "success");
        this.getData();
        this.reset();
      });
    }

    if (m == 1.1) {
      //UPDATE COMPANY
      var obj = JSON.parse(JSON.stringify(this.flags.editCompany));
      delete obj.join;

      this.http.apiPut("company/id/" + obj.id, { data: obj }, null).then((data) => {
        this.app.toast("Saved", "success");
        this.getData();
        this.reset();
      });
    }

    if (m == 2) {
      //save new user
      var obj = JSON.parse(JSON.stringify(this.flags.editAccess));
      this.http.apiPost("user_accounts", { data: obj }, null).then((data) => {
        this.app.toast("Saved", "success");
        //this.getUsers();
        //this.reset();
      });
    }

    if (m == 2.1) {
      //update user
      //var obj:any = { id: this.flags.editAccess.join_id, first_name: this.flags.editAccess.join_first_name, last_name: this.flags.editAccess.join_last_name };

      //delete temp.payroll_json;
      var obj = JSON.parse(JSON.stringify(this.flags.editUser));
      delete obj.join;

      this.http.apiPut("user_accounts/id/" + obj.id, { data: obj }, null).then((data) => {
        this.app.toast("Saved", "success");
        this.getData();
        this.reset();
        //this.reset();
      });
    }

    if (m == 3) {
      //save new access
      var obj = JSON.parse(JSON.stringify(this.flags.editAccess));
      this.http.apiPost("user_access", { data: obj }, null).then((data) => {
        this.app.toast("Saved", "success");
        this.closeModal();
        this.getData();
        this.reset();
      });
    }
  }

  updateAccess(item) {
    this.http.apiPut("user_access/id/" + item.id, { data: item }, null).then((data) => {
      this.app.toast("Saved", "success");
      this.closeModal();
      this.getData();
      //this.reset();
    });
  }

  deleteItem(m, params) {
    if (m == 2.1) {
      var id = this.flags.editCompany.id;
      this.http.apiDelete("company/id/" + id, null).then((data) => {
        this.app.presentToast("Company Removed", "success");
        //this.getFolders();
        this.getData();
        this.reset();
      });
    }

    if (m == 3.1) {
      console.log(params);

      var id = params.id;
      this.http.apiDelete("user_access/id/" + id, null).then((data) => {
        this.app.presentToast("Access Removed", "success");
        //this.getFolders();
        this.getData();
        this.reset();
      });
    }

    if (m == 4) {
      var id = params.id;
      this.http.apiDelete("company_sites/id/" + id, null).then((data) => {
        this.app.presentToast("Site Removed", "success");
        //this.getFolders();
        this.closeModal();
        this.getData();
        this.reset();
      });
    }
  }

  reset() {
    this.flags.editCompany = null;
    this.flags.editUser = null;
    this.flags.editAccess = null;
  }

  ngOnInit() {
    this.title.setTitle("🔒 Admin Console");
  }

  async presentAlertConfirm(m, params) {
    const alert = await this.alertController.create({
      header: "Are you sure?",
      message: "This cannot be undone",
      buttons: [
        {
          text: "Cancel",
          role: "cancel",
          cssClass: "secondary",
          handler: (blah) => {
            console.log("Confirm Cancel: blah");
          },
        },
        {
          text: "Okay",
          handler: () => {
            if (m == 2.1) {
              this.deleteItem(m, null);
              console.log("Confirm Okay");
            }

            if (m == 3.1) {
              this.deleteItem(m, params);
            }

            if (m == 4) {
              this.deleteItem(m, params);
            }
          },
        },
      ],
    });

    await alert.present();
  }
}
